(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jh-faq-hub"] && !Shopify.designMode) return;
  try {
    
// Highlight the jump link for whichever group is currently in view.
// IntersectionObserver with a narrow rootMargin proved unreliable here: the
// groups are taller than the band, so entries stayed "intersecting" and never
// re-fired. Picking the last group whose top has passed a fixed offset is
// deterministic at any scroll position, including on load and on resize.
document.querySelectorAll('.jh-faqhub').forEach((root) => {
  const links = Array.from(root.querySelectorAll('.jh-faqhub__jump'));
  const groups = links.map((l) => root.querySelector(l.getAttribute('href')));
  if (!groups.length || groups.some((g) => !g)) return;

  let queued = false;
  function sync() {
    queued = false;
    const line = window.innerHeight * 0.3;
    let current = 0;
    groups.forEach((g, i) => {
      if (g.getBoundingClientRect().top <= line) current = i;
    });
    links.forEach((l, i) => l.classList.toggle('is-active', i === current));
  }
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  // Horizon scrolls an inner wrapper, not the window, so a window scroll
  // listener never fires here. Scroll events don't bubble but they do reach a
  // capture-phase listener on document, whichever element is scrolling.
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll);
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-main-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-jh-sortform]').forEach((form) => {
  form.querySelector('[data-jh-sort]')?.addEventListener('change', () => form.submit());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('.jhv-player').forEach(function (player) {
        if (player.dataset.jhvBound) return;
        player.dataset.jhvBound = '1';
        var video = player.querySelector('.jhv-player__el');
        var btn = player.querySelector('.jhv-player__btn');
        function toggle() { if (video.paused) { video.play(); } else { video.pause(); } }
        if (btn) btn.addEventListener('click', toggle);
        video.addEventListener('click', toggle);
        video.addEventListener('play', function () { player.classList.add('is-playing'); });
        video.addEventListener('pause', function () { player.classList.remove('is-playing'); });
        video.addEventListener('ended', function () { player.classList.remove('is-playing'); video.load(); });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
